import { render } from "./SponsorsPage.vue?vue&type=template&id=f260e57a"
import script from "./SponsorsPage.vue?vue&type=script&lang=js"
export * from "./SponsorsPage.vue?vue&type=script&lang=js"

import "./SponsorsPage.vue?vue&type=style&index=0&id=f260e57a&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__